import { render, staticRenderFns } from "./OrderReviewCartDetails.vue?vue&type=template&id=7040ed56&scoped=true&"
import script from "./OrderReviewCartDetails.vue?vue&type=script&lang=js&"
export * from "./OrderReviewCartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040ed56",
  null
  
)

export default component.exports